<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <form
          @keyup.enter="
            pageNo = 1;
            getData();
          "
        >
          <div class="vx-row mb-2">
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>از تاریخ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5  w-full"
                    v-model="filters.dateFrom"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>تا تاریخ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5 w-full"
                    v-model="filters.dateTo"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>از مبلغ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.minAmount"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>تا مبلغ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.maxAmount"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>وضعیت:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <v-select
                    class="selectExample w-full"
                    v-model="filters.billState"
                    :options="billStateList"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>متن:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input v-model="filters.filter" class="w-full" />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col">
              <vs-button
                @click="clear"
                class="mx-3"
                color="primary"
                type="border"
                >پاک کردن</vs-button
              >
            </div>
            <div class="vx-col">
              <vs-button
                @click="
                  pageNo = 1;
                  getData();
                "
                class="mx-3"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                >جستجو</vs-button
              >
            </div>
          </div>
        </form>
      </vs-collapse-item>
    </vs-collapse>
    <vx-card
      :title="
        this.$route.query.title
          ? 'قبض های دریافتی &quot;' + this.$route.query.title + '&quot;'
          : ''
      "
    >
      <div class="vx-row mb-2" v-if="this.$route.query.userId">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="$router.go(-1)"
            type="flat"
            icon-pack="feather"
            icon="icon-chevron-right"
            >بازگشت</vs-button
          >
        </div>
      </div>
      <vs-table
        id="tbl2"
        ref="tbl2"
        class="responsable-table"
        stripe
        :data="tableData"
      >
        <template slot="header">
          <div class="vx-row mb-2">
            <div class="vx-col">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">
                    {{ (pageNo - 1) * pageSize + 1 }}
                    -
                    {{
                      pageNo * pageSize > totalCount
                        ? totalCount
                        : pageNo * pageSize
                    }}
                    از {{ totalCount }}
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="SetPageSize(5)">
                    <span>5</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="SetPageSize(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="SetPageSize(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="SetPageSize(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="SetPageSize(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="SetPageSize(150)">
                    <span>150</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th class="px-0"></vs-th>
          <!-- <vs-th class="px-0"></vs-th> -->
          <vs-th class="px-0 mx-0">ردیف</vs-th>
          <vs-th sort-key="title" key="title">عنوان</vs-th>
          <vs-th sort-key="consumerName" key="consumerName">صادر کننده</vs-th>
          <vs-th sort-key="totalAmount" key="totalAmount">مجموع اقساط</vs-th>
          <vs-th sort-key="description" key="description">توضیحات</vs-th>
          <vs-th sort-key="merchantDescription" key="merchantDescription"
            >سایر</vs-th
          >
          <vs-th sort-key="creationDateTime" key="creationDateTime"
            >تاریخ صدور</vs-th
          >
          <vs-th
            sort-key="billStateChangeDateTime"
            key="billStateChangeDateTime"
            >{{ isGroup ? "تاریخ آخرین تغییر" : "تاریخ پرداخت" }}</vs-th
          >
          <vs-th
            class="px-0 mx-0"
            sort-key="billState"
            key="billState"
            v-if="!isGroup"
            >وضعیت</vs-th
          >
          <vs-th v-if="!isGroup"></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :id="tr.id"
            :data="tr"
            :key="tr.Id"
            v-for="(tr, indextr) in data"
          >
            <vs-td class="px-0 m-0 d-only">
              <feather-icon
                v-if="tr.isGroup"
                icon="UsersIcon"
                svgClasses="h-4 w-4"
                class="p-2"
              ></feather-icon>
            </vs-td>
            <!-- <vs-td class="px-0 m-0 d-only">
              <vx-tooltip :text="tr.isRead?'خوانده شده':'خوانده نشده'">
                <div
                  class="h-3 w-3 rounded-full p-0 m-0 mr-2"
                  :class="{'border-2 border-solid d-theme-border-grey-light':tr.isRead,'bg-success':!tr.isRead}"
                ></div>
              </vx-tooltip>
            </vs-td> -->
            <vs-td class="pr-0 pl-1 d-only">{{
              pageSize * (pageNo - 1) + indextr + 1
            }}</vs-td>
            <vs-td>{{ tr.title }}</vs-td>
            <vs-td>{{ tr.merchantName }}</vs-td>
            <vs-td>
              {{ formatAmount(tr.totalAmount) }}
              <span class="m-only">
                <vs-button
                  color="success"
                  v-if="tr.isGroup"
                  type="line"
                  icon-pack="feather"
                  icon="icon-layers"
                  class="p-0 float-right"
                  @click="gotoRecivers(tr)"
                  >اقساط</vs-button
                >
                <template v-else>
                  <vs-button
                    color="success"
                    type="line"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    class="p-0 pb-1 float-right"
                    v-if="tr.billState == 1"
                    @click="showTransaction(tr.transactionId)"
                    >جزئیات</vs-button
                  >
                  <vs-button
                    class="p-2 float-right"
                    :color="BillState[tr.billState].color"
                    v-else-if="tr.billState == 0"
                    icon-pack="feather"
                    icon="icon-credit-card"
                    target="_blunk"
                    :href="`https://pay.bistpay.com/2/2/${tr.billReceiverId}`"
                    >پرداخت</vs-button
                  >
                  <share-links
                    class="float-right"
                    btnText="اشتراک"
                    :cssClass="'p-0 text-' + BillState[tr.billState].color"
                    :message="
                      'https://pay.bistpay.com/2/2/' + tr.billReceiverId
                    "
                    :receiver="tr.consumerMobile"
                  ></share-links>
                </template>
              </span>
            </vs-td>
            <vs-td class="e-col">
              <vx-tooltip title="توضیحات" :text="tr.description"
                >{{ tr.description.slice(0, 10)
                }}{{ tr.description.length > 10 ? "..." : "" }}</vx-tooltip
              >
              <template v-if="!tr.description">&nbsp;</template>
            </vs-td>
            <vs-td class="e-col hide-title py-0">
              <template v-if="!$helper.isJSON(tr.merchantDescription)">{{
                tr.merchantDescription
              }}</template>
              <template v-else>
                <span
                  class="mx-0 block py-1"
                  :key="item"
                  v-for="item in tr.merchantDescription
                    ? Object.keys(JSON.parse(tr.merchantDescription))
                    : []"
                >
                  <span class="text-grey">{{ item }}:</span>
                  {{ JSON.parse(tr.merchantDescription)[item] }}
                </span>
              </template>
            </vs-td>
            <vs-td class="e-col" title="تاریخ صدور">{{
              !tr.creationTime
                ? "&nbsp;"
                :$moment(tr.creationTime).format("HH:mm:ss jYYYY/jM/jD")
            }}</vs-td>
            <vs-td class="e-col" title="تارخ آخرین وضعیت">{{
              !tr.billStateChangeDateTime
                ? "&nbsp;"
                :$moment(tr.billStateChangeDateTime).format(
                    "HH:mm:ss jYYYY/jM/jD"
                  )
            }}</vs-td>
            <vs-td class="d-only px-2" v-if="!isGroup">
              <span>
                <feather-icon
                  :title="BillState[tr.billState].title"
                  :icon="BillState[tr.billState].icon"
                  :svgClasses="[
                    `h-6 w-6 stroke-current text-${
                      BillState[tr.billState].color
                    }`,
                  ]"
                ></feather-icon>
              </span>
            </vs-td>
            <vs-td class="d-only px-2" v-if="!tr.isGroup">
              <share-links
                :cssClass="'text-' + BillState[tr.billState].color"
                :message="'https://pay.bistpay.com/2/2/' + tr.billReceiverId"
                btnText="اشتراک"
              ></share-links>
              <!--  -->
            </vs-td>
            <vs-td class="d-only px-2">
              <vs-button
                color="success"
                v-if="tr.isGroup"
                type="line"
                class="pb-1 px-0 one-line"
                @click="gotoRecivers(tr)"
                >مشاهده‌ اقساط</vs-button
              >
              <template v-else>
                <vs-button
                  color="success"
                  type="line"
                  class="pb-1 px-0 one-line"
                  v-if="tr.billState == 1"
                  @click="showTransaction(tr.transactionId)"
                  >جزئیات</vs-button
                >
                <vs-button
                  color="warning"
                  type="line"
                  class="pb-1 px-0"
                  v-else-if="tr.billState == 0"
                  target="_blunk"
                  :href="`https://pay.bistpay.com/2/2/${tr.billReceiverId}`"
                  >پرداخت</vs-button
                >
              </template>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>      
      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="getData"
      />
    </vx-card>

    <transaction-details ref="TransactionDetails1"></transaction-details>
  </div>
</template>
<style lang="scss">
.remove-nav {
  background: #ea5455;
  color: #eee;
}
.excel-import div,
.remove-nav {
  padding-top: 0 !important;
  padding-bottom: 17px !important;
}
.excel-import div span,
.remove-nav span {
  display: inline-block !important;
  bottom: -1em;
  margin-left: 1em;
}
.is-blocked {
  border-width: 0;
  border-left-width: 6px;
  border-right-width: 6px;
  border-style: dashed;
  border-color: red;
}
</style>
<script>
import TransactionDetails from "../transaction/TransactionDetails.vue";
import ShareLinks from "./ShareLinks.vue";
import { BillState } from "@/enums.js";
import vSelect from "vue-select";
export default {
  name: "consumer-bills",
  props: {
    isGroup: { default: false, type: Boolean },
  },
  components: {
    ShareLinks,
    TransactionDetails,
    "v-select": vSelect,
  },
  data() {
    return {
      tableData: [],
      BillState,
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      BillState,
      billReceiversVisible: false,
      filters: {
        billState: "",
        maxAmount: "",
        minAmount: "",
        dateTo: "",
        dateFrom: "",
        filter: "",
      },
    };
  },
  computed: {
    billStateList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.BillState)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
  },
  methods: {
    clear() {
      this.filters.filter = "";
      this.filters.dateFrom = "";
      this.filters.dateTo = "";
      this.filters.minAmount = "";
      this.filters.maxAmount = "";
      this.filters.billState = null;
    },
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filters.filter = this.$route.query.f || this.filters.filter;
        this.filters.minAmount = this.$route.query.na || this.filters.minAmount;
        this.filters.maxAmount = this.$route.query.xa || this.filters.maxAmount;
        this.filters.dateFrom = this.$route.query.df || this.filters.dateFrom;
        this.filters.dateTo = this.$route.query.dt || this.filters.dateTo;
        this.filters.billState = this.$route.query.bs
          ? this.billStateList.find((x) => x.value == this.$route.query.bs)
          : null;
      }
    },
    getData() {
      let payload = {
        params: {
          maxResultCount: this.pageSize,
          skipCount: this.pageSize * (this.pageNo - 1),
          filter: this.filters.filter,
          billStates:
            this.filters.billState == null
              ? null
              : this.filters.billState.value,
        },
      };
      if (this.filters.maxAmount) payload.maxAmount = this.filters.maxAmount;
      if (this.filters.minAmount) payload.minAmount = this.filters.minAmount;
      const query = {};
      if (this.$route.query.userId) {
        query.userId = this.$route.query.userId;
        query.title = this.$route.query.title;
        payload.params.ConsumerUserId = this.$route.query.userId;
      }
      query.ps = this.pageSize;
      query.pno = "" + this.pageNo;
      if (this.filters.maxAmount) query.xa = this.filters.maxAmount;
      if (this.filters.minAmount) query.na = this.filters.minAmount;
      if (this.filters.filter) query.f = this.filters.filter;
      if (this.filters.billState) query.bs = this.filters.billState.value;
      if (this.filters.dateFrom != "") {
        payload.params.dateFrom = this.$moment(
          this.filters.dateFrom,
          "jYYYY/jMM/jDD"
        ).format();
        query.df = this.filters.dateFrom;
      }
      if (this.filters.dateTo != "") {
        payload.params.dateTo = this.$moment(
          this.filters.dateTo,
          "jYYYY/jMM/jDD"
        ).format("YYYY-MM-DDT23:59:59.9999999Z");
        query.dt = this.filters.dateTo;
      }

      if (!this.$helper.equal(this.$route.query, query))
        this.$router.replace({
          query: query,
        });

      this.$vs.loading();
      this.$http
        .get(
          `api/services/app/Bills/` +
            (this.isGroup
              ? "GetBookletForConsumer"
              : "GetSingleBillsForConsumer"),
          payload
        )
        .then((response) => {
          this.tableData = response.data.result.items;
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    formatAmount(val) {
      val = val.toString().replace(/,/g, "");
      if (isNaN(parseInt(val))) return val;
      else return parseInt(val).toLocaleString();
    },
    showTransaction(id) {
      this.$refs.TransactionDetails1.show(id);
    },
    gotoRecivers(tr) {
      // //read bill
      // if (!tr.isRead) {
      //   this.$http.post(`api/services/app/Bills/ReadBill?billId=${tr.billId}`);
      // }

      if (tr.isGroup) {
        this.$router.push({
          name: "consumer-bill-receivers",
          query: {
            title: tr.title,
            billId: tr.id,
          },
        });
      }
    },
  },
  mounted() {
    this.initFilters();
    this.getData();
  },
  updated() {},
};
</script>
